export default __webpack_public_path__ + "static/media/plus-green.da88c253.svg";